var _path, _mask, _path2, _path3, _path4, _path5, _rect, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandouts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.804,
    d: "M4.914 2.053h8.059M4.914 5.733h8.06M4.914 9.27h8.06"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "handouts_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.28 4.086a1.92 1.92 0 00-.699-1.482L12.951.438A1.92 1.92 0 0011.73 0H1.92C.86 0 0 .86 0 1.92v15.203c0 1.06.86 1.92 1.92 1.92h12.44c1.061 0 1.92-.86 1.92-1.92V4.086z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.28 4.086a1.92 1.92 0 00-.699-1.482L12.951.438A1.92 1.92 0 0011.73 0H1.92C.86 0 0 .86 0 1.92v15.203c0 1.06.86 1.92 1.92 1.92h12.44c1.061 0 1.92-.86 1.92-1.92V4.086z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95.438l.511-.62-.51.62zm2.631 2.166l-.51.62.51-.62zm.511-.62l-2.63-2.167-1.023 1.241 2.631 2.167 1.022-1.241zM1.92.804h9.81V-.804H1.92V.804zM.804 17.123V1.92H-.804v15.203H.804zm13.557 1.116H1.92v1.607h12.44V18.24zm1.116-14.153v13.037h1.607V4.086h-1.607zm-1.116 15.76a2.724 2.724 0 002.723-2.723h-1.607c0 .616-.5 1.116-1.116 1.116v1.607zM-.804 17.123a2.724 2.724 0 002.724 2.723V18.24c-.617 0-1.116-.5-1.116-1.116H-.804zM1.92-.804A2.724 2.724 0 00-.804 1.92H.804c0-.617.5-1.116 1.116-1.116V-.804zm11.541.621a2.724 2.724 0 00-1.731-.62V.803c.259 0 .51.09.71.254l1.021-1.24zm1.61 3.408c.257.212.406.528.406.861h1.607c0-.813-.364-1.585-.992-2.102l-1.022 1.24z",
    fill: "currentColor",
    mask: "url(#handouts_svg__a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 3.619V1.527l2.589 2.17-2.537-.037c-.029 0-.052-.019-.052-.041z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.804
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.804,
    d: "M2.11 3.823h8.06M1.96 6.598h4.92"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.398,
    y: 5.398,
    width: 14.601,
    height: 14.601,
    rx: 7.301,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "handouts_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 8,
    width: 13,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M6.141 8.527h11.863v10.429H6.141z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#handouts_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.477 15.741a.571.571 0 01-.574.019c-.193-.097-.29-.246-.29-.448v-5.225c0-.202.097-.352.29-.449a.572.572 0 01.574.02l4.617 2.612c.17.101.255.244.255.43a.474.474 0 01-.255.428l-4.617 2.613z",
    fill: "#fff"
  }))));
}
export default SvgHandouts;